// Carrier Map Logs
export const API_GET_ONE_CARRIER_MAP_LOG = "API_GET_ONE_CARRIER_MAP_LOG"
export const RESET_CARRIER_MAP_LOG = "RESET_CARRIER_MAP_LOG"
